import { render, staticRenderFns } from "./BilleteIcon.vue?vue&type=template&id=a5b71a34&"
import script from "./BilleteIcon.vue?vue&type=script&lang=js&"
export * from "./BilleteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports